export default "__VITE_ASSET__DfjYwZCW__"